import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { StorageService } from "src/app/services/storage.service";
import { environment } from "src/environments/environment";
//import { YoutubeVideoPlayer } from '@awesome-cordova-plugins/youtube-video-player/ngx';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { GlobalsService } from "src/app/api/globals.service";
import { Platform } from "@ionic/angular";
import { TimerService } from "src/app/services/timer.service";

@Component({
  selector: "app-opcion-multiple",
  templateUrl: "./opcion-multiple.component.html",
  styleUrls: ["./opcion-multiple.component.scss"],
})
export class OpcionMultipleComponent implements OnInit {
  @Input() public DATA: any;
  @Input() public OPCIONES: any;
  @Input() public curso: any;
  @Input() public ID_TIPO_LC: any;
  @Output() public isvalid = new EventEmitter<boolean>();
  @Output() public name = new EventEmitter<string>();
  public host = environment.host + "/";
  public activityCourse: any;
  ismobile: boolean;
  public explicacion: string = "";
  public setActiveOp;

  private ID_TIPO = 1;

  inicio_actividad_key: string;
  private ID_ACTIVIDAD = 0;
  sqliteStorage: boolean = false;
  sqliteStorageData: any = null;
  private readonly table = "actividades_respuestas_data";
  constructor(
    private storageService: StorageService,
    //private youtube: YoutubeVideoPlayer,
    private domSanitizer: DomSanitizer,
    //public trustedVideoUrl:SafeResourceUrl
    private platform: Platform,
    public globalsService: GlobalsService,
    private timerService: TimerService
  ) {
    this.ismobile = globalsService.isMobile;
  }
  playVideo() {
    //this.youtube.openVideo('Mv7hHrw1ymQ');
  }
  respuesta: any;
  ngOnInit() {
    console.log("DATA: ", this.DATA);
    this.name.emit("Opción Múltiple");
    this.explicacion = this.DATA.explicacion;
    this.ID_ACTIVIDAD = this.DATA.id_actividad;
    /******************* */
    let _id_librocurso = this.ID_ACTIVIDAD;
    let id_tipo = this.ID_TIPO;
    let id_ejercicio = this.DATA.id;
    let _id_curso = this.curso.id;
    let _tipo = this.ID_TIPO_LC;
    let _id_user = this.curso.id_user;
    const key = `inicio_actividad_${_id_curso}_${_id_librocurso}_${_id_user}_${_tipo}_${id_ejercicio}_${id_tipo}`;
    console.log("DATA ->KEY:", key);
    this.inicio_actividad_key = key;
    /******************* */
    this.platform.ready().then(() => {
      this.getStorage();
    });
  }
  async getStorage() {
    let activityCourse: any;
    this.storageService
      .get("activities")
      .then((res) => {
        if (res) {
          this.setActiveOp = 0;
          activityCourse = res.find(
            (x) =>
              x.id_actividad == this.ID_ACTIVIDAD && x.id == this.curso.id
          );
          activityCourse.data.forEach((element2, j) => {
            if (
              element2.id_tipo == this.DATA.id_tipo &&
              element2.id == this.DATA.id
            ) {
              this.setActiveOp = element2.respuesta.r.id;
              this.timerService.initTimer(element2.timer);
              this.isvalid.emit(true);
            }
          });
        }
      })
      .catch((err) => {
        console.log('storageService error',err);
      });
  }
  public sanitizer(videoURL) {
    //let trustedVideoUrl = this.domSanitizer.bypassSecurityTrustUrl(videoURL)
    return this.domSanitizer.bypassSecurityTrustUrl(videoURL);
  }
  selectOption(event: any) {
    let id = event.target.dataset.id;
    let btns = document.getElementsByClassName("btn-color-default");
    for (let i = 0; i < btns.length; i++) {
      btns[i].classList.remove("active");
    }
    this.OPCIONES.forEach((element) => {
      if (id == element.id) {
        this.respuesta = {
          id: id,
          opcion: element.opcion,
        };
        this.isvalid.emit(true);
      }
    });
    this.storageService
      .get("activities")
      .then((res) => {
        if (res) {
          console.log("🚀 ~ OpcionMultipleComponent ~ .then ~ res:", res);
          this.activityCourse = res;
          //let data:any = this.activityCourse.data;
          this.activityCourse.forEach((element, i) => {
            if (element.id == this.curso.id &&
              element.id_actividad == this.ID_ACTIVIDAD) {
              let data: any;
              data = {
                id: this.DATA.id,
                id_actividad: this.DATA.id_actividad,
                id_tipo: this.DATA.id_tipo,
                respuesta: {
                  r: this.respuesta,
                },
              };
              if (element.data.length == 0) {
                element.data.push(data);
              } else {
                let find: boolean = false;
                element.data.forEach((element2, j) => {
                  console.log("element2.id:", element2);
                  if (
                    element2.id_tipo == this.DATA.id_tipo &&
                    element2.id == this.DATA.id
                  ) {
                    element.data[j] = data;
                    find = true;
                  }
                });
                if (!find) {
                  element.data.push(data);
                }
              }
            }
          });

          console.log("storageService data: ", this.activityCourse);
          this.storageService.storage("activities", this.activityCourse);
        } else {
          this.storageService.storage("activities", this.activityCourse);
          console.log("storageService set: ", this.activityCourse);
        }
      })
      .catch((err) => {
        //this.storageService = null;
        console.log("storageService error", err);
      });
    /************************************* */
    //console.log('Respuesta: ',this.respuesta);
    document.getElementById("option-id-" + id).classList.add("active");
  }
}
